export default {
    baseStyle: {
        fontWeight: 500,
        padding: '4px 16px',
    },
    variants: {
        incomplete: {
            backgroundColor: 'gray.200',
            color: 'black',
        },
        current: {
            backgroundColor: 'orange.400',
            color: 'white',
            fontWeight: 600,
        },
        complete: {
            backgroundColor: 'blue.900',
            color: 'white',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RhdHVzVHJhY2tlclN0ZXAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi9hcGV4LW9ubGluZS9jb21wb25lbnQtbGlicmFyeS90aGVtZS9jb21wb25lbnRzL1N0YXR1c1RyYWNrZXJTdGVwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGVBQWU7SUFDYixTQUFTLEVBQUU7UUFDVCxVQUFVLEVBQUUsR0FBRztRQUNmLE9BQU8sRUFBRSxVQUFVO0tBQ3BCO0lBQ0QsUUFBUSxFQUFFO1FBQ1IsVUFBVSxFQUFFO1lBQ1YsZUFBZSxFQUFFLFVBQVU7WUFDM0IsS0FBSyxFQUFFLE9BQU87U0FDZjtRQUNELE9BQU8sRUFBRTtZQUNQLGVBQWUsRUFBRSxZQUFZO1lBQzdCLEtBQUssRUFBRSxPQUFPO1lBQ2QsVUFBVSxFQUFFLEdBQUc7U0FDaEI7UUFDRCxRQUFRLEVBQUU7WUFDUixlQUFlLEVBQUUsVUFBVTtZQUMzQixLQUFLLEVBQUUsT0FBTztTQUNmO0tBQ0Y7Q0FDRixDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICBiYXNlU3R5bGU6IHtcbiAgICBmb250V2VpZ2h0OiA1MDAsXG4gICAgcGFkZGluZzogJzRweCAxNnB4JyxcbiAgfSxcbiAgdmFyaWFudHM6IHtcbiAgICBpbmNvbXBsZXRlOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6ICdncmF5LjIwMCcsXG4gICAgICBjb2xvcjogJ2JsYWNrJyxcbiAgICB9LFxuICAgIGN1cnJlbnQ6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogJ29yYW5nZS40MDAnLFxuICAgICAgY29sb3I6ICd3aGl0ZScsXG4gICAgICBmb250V2VpZ2h0OiA2MDAsXG4gICAgfSxcbiAgICBjb21wbGV0ZToge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiAnYmx1ZS45MDAnLFxuICAgICAgY29sb3I6ICd3aGl0ZScsXG4gICAgfSxcbiAgfSxcbn1cbiJdfQ==